import { message } from 'antd'
import useFetch from 'elements/Hooks/useFetch'
import { VendorQuoteApi } from '../../../../api/Purchase/VendorQuotes'
import VendorQuotesLines from '../../../../components/Purchasing/VendorQuotes/Lines/VendorQuotesLines'
import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import { get, isEmpty } from 'lodash'
import React from 'react'

import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'

function VendorQuotesLinesCont(props) {
  const { vendorQuote, isUpdatable } = props
  const { data: list, fetching, fetch } = useFetch({
    url: `vendorQuotes/lines/${vendorQuote._key}`,
  })

  const enquiryId = get(vendorQuote, 'enquiry._id') || ''

  const { data: enquiry } = useFetch({
    url: `enquiries/${enquiryId.replace('activities/', '')}`,
    dependencyArray: [fetching, vendorQuote._id, enquiryId],
    dontFetch: isEmpty(enquiryId),
  })

  const {
    visible,
    modalType,
    object: line,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
  } = useModalData(undefined, VendorQuoteApi.lines.update, VendorQuoteApi.lines.remove, fetch)

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await VendorQuoteApi.lines.create({
        ...newObject,
        spquote: { _id: vendorQuote._id },
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <VendorQuotesLines
      {...{
        list,
        isUpdatable,
        fetching,
        fetch,
        visible,
        submitting,
        vendorQuote,
        line,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
        enquiry,
      }}
    />
  )
}

VendorQuotesLinesCont.propTypes = {}
VendorQuotesLinesCont.defaultProps = {}

export default VendorQuotesLinesCont
